import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function TrendPanel({ trends }) {
  const { t } = useApp();
  if (!trends) return null;
  const mapLabel = (l) =>
    l === "Haussière" ? t("trend.bullish", "Haussière") :
    l === "Baissière" ? t("trend.bearish", "Baissière") :
    l === "Neutre" ? t("trend.neutral", "Neutre") : l;
  const rows = [
    { key: "past", label: t("trend.past", "Tendance Passée"), data: trends.past, testid: "trend-past" },
    { key: "current", label: t("trend.current", "Tendance Actuelle"), data: trends.current, testid: "trend-current" },
    { key: "future", label: t("trend.future", "Tendance Future"), data: trends.future, testid: "trend-future" },
  ];
  return (
    <div className="panel p-4 space-y-4" data-testid="trend-panel">
      <div className="flex items-center justify-between">
        <div className="panel-title text-[14px]">{t("trend.title", "Analyse de Tendance")}</div>
      </div>
      {rows.map((r) => {
        const c = r.data || { label: "—", confidence: 0 };
        const Icon = c.label === "Haussière" ? TrendingUp : c.label === "Baissière" ? TrendingDown : Minus;
        const color = c.label === "Haussière" ? "text-up" : c.label === "Baissière" ? "text-down" : "text-warn";
        const bar = c.label === "Haussière" ? "var(--up)" : c.label === "Baissière" ? "var(--down)" : "var(--warn)";
        return (
          <div key={r.key} data-testid={r.testid}>
            <div className="flex items-center justify-between mb-2">
              <div className="text-xs text-white/60 uppercase tracking-wide">{r.label}</div>
              <div className={`flex items-center gap-1.5 text-sm font-medium ${color}`}>
                <Icon size={14} strokeWidth={2.2} />
                {mapLabel(c.label)}
              </div>
            </div>
            <div className="pbar">
              <span style={{ width: `${c.confidence}%`, background: bar }} />
            </div>
            <div className="text-[11px] font-mono text-white/50 mt-1">{t("trend.confidence", "Confiance")} {c.confidence}%</div>
          </div>
        );
      })}
    </div>
  );
}
